import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ChangePasswordStore } from '../store/change-password.store';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { PasswordInputComponent } from '../../../../shared/ui/password-input';
import { MatDialogRef } from '@angular/material/dialog';
import { ForgotPasswordStore } from '../../forgot-password/store/forgot-password.store';
import { ConfirmPasswordComponent } from '../confirm-password/confirm-password.component';
import { MatDividerModule } from '@angular/material/divider';
import { ResetForgottenPasswordComponent } from '../reset-forgotten-password/reset-forgotten-password.component';
import { TranslatePipe } from '../../../shared/pipes/translationPipe';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDividerModule,
    PasswordInputComponent,
    ResetForgottenPasswordComponent,
    ConfirmPasswordComponent,
    TranslatePipe,
    AsyncPipe,
  ],
  providers: [ChangePasswordStore, ForgotPasswordStore],
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangePasswordComponent {
  readonly store = inject(ChangePasswordStore);
  readonly dialogRef = inject(MatDialogRef<ChangePasswordComponent>);

  onSubmitOldPassword(): void {
    const control = this.store.passwordForm.get('oldPassword');
    const oldPassword = control?.value;

    if (!control || control.invalid || !oldPassword) return;

    this.store.confirmOldPassword({
      oldPassword,
      control,
    });
  }
}
